import { Box, Link, Typography } from '@mui/material';
import React from 'react';

import { IMenuItem } from '../types';

import { SubmenuItemTooltip } from './SubmenuItemTooltip';

interface ISubmenuItemTextProps {
  showTooltip: boolean;
  item: Pick<IMenuItem, 'label' | 'id' | 'url' | 'openInNewTab' | 'onClick' | 'linkComponent'>;
  lightFontWeight: boolean;
  labelRef: React.MutableRefObject<any>;
  starRef?: React.MutableRefObject<any>;
  handleMenuClick(): void;
}

export const SubmenuItemText: React.FC<ISubmenuItemTextProps> = ({
  showTooltip,
  item,
  lightFontWeight,
  labelRef,
  starRef,
  handleMenuClick
}) => {
  const textStyles = {
    width: '100%',
    border: 'none',
    padding: 0.5, // For focus outline
    textAlign: 'inherit',
    backgroundColor: 'inherit',
    ':focus-visible': {
      backgroundColor: 'action.hover',
      outline: (theme: any) => `2px solid ${theme.palette.primary.main}`,
      outlineOffset: -2,
      borderRadius: 1
    }
  };
  const variant = lightFontWeight ? 'bodyDefault' : 'h5';
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && starRef?.current) {
      starRef.current.focus();
    }
  };
  return (
    <SubmenuItemTooltip title={showTooltip ? item.label : ''}>
      <Box
        sx={{ overflow: 'hidden', alignItems: 'center', flexGrow: 1, minHeight: 24, display: 'flex', width: '100%' }}
      >
        {item.url ? (
          <Link
            href={item.url}
            component={item.linkComponent || 'a'}
            target={item?.openInNewTab ? '_blank' : undefined}
            underline="none"
            color="text.primary"
            sx={{
              ...textStyles,
              ':visited': {
                color: 'text.primary'
              },
              ':hover': {
                textDecoration: 'none'
              },
              display: 'block',
              fontSize: '14px'
            }}
            variant={variant}
            noWrap={true}
            ref={labelRef}
            onClick={handleMenuClick}
            onKeyDown={handleKeyDown}
            tabIndex={-1}
          >
            {item.label}
          </Link>
        ) : (
          <Typography
            variant={variant}
            component={item?.onClick ? 'button' : 'span'}
            sx={{
              ...textStyles,
              color: 'inherit',
              cursor: item?.onClick ? 'pointer' : 'inherit',
              fontSize: '14px'
            }}
            noWrap={true}
            ref={labelRef}
            onKeyDown={handleKeyDown}
            onClick={item?.onClick ? handleMenuClick : undefined}
            tabIndex={-1}
          >
            {item.label}
          </Typography>
        )}
      </Box>
    </SubmenuItemTooltip>
  );
};
